import type { Dict } from '../lib/locales/en';
import type { ProductId } from './products';

/** Role keys, translated in `lib/locales/*`. Add a key there before using it here. */
export type RoleId = keyof Dict['roles'];

export interface Member {
  /** A person's name is a proper noun — the same in every language, never translated. */
  name: string;
  role: RoleId;
  /**
   * Optional headshot in `public/team/`. Without one the card falls back to the
   * person's initials, so a roster can go live before the photo shoot does.
   */
  photo?: string;
}

/**
 * The holding's own founders. Rendered above the product teams, because they are
 * who the company is rather than who a given product is.
 *
 * TODO(vaqtly): placeholders — see the note on `team` below.
 */
export const founders: Member[] = [
  /* TODO(vaqtly): name taken from this machine's git config — confirm the spelling. */
  { name: 'Mukhammadkarim Tukhtaboev', role: 'founderCeo' },
  { name: 'Ism Familiya', role: 'cofounder' },
];

/**
 * The people behind each product, grouped by the product they work on.
 *
 * TODO(vaqtly): every entry here and in `founders` is a placeholder — "Ism
 * Familiya" is literally "First-name Surname". Replace the whole roster with the
 * real people before this ships; do not launch with these names visible.
 */
export const team: Record<ProductId, Member[]> = {
  'russian-gg': [
    { name: 'Ism Familiya', role: 'founder' },
    { name: 'Jasurbek Abdunazarov', role: 'cto' },
    { name: 'Ism Familiya', role: 'content' },
    { name: 'Ism Familiya', role: 'marketing' },
  ],
  sevil: [
    { name: 'Ism Familiya', role: 'founder' },
    { name: 'Ism Familiya', role: 'engineer' },
    { name: 'Ism Familiya', role: 'designer' },
    { name: 'Ism Familiya', role: 'product' },
  ],
};

/** Initials for the fallback avatar: first letter of the first two words. */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toUpperCase();
}
